import React from "react"
import ReactApexChart  from "react-apexcharts";
import {transactionCat, formatAmount} from "../../../../../../../../../util/Helpers";

const TransactionChart = ({transactions, currency}) => {


    /* Generate Chart Record for six months from the transaction list  */
    const trnx = [...transactions].reverse();
    const record = {inflow: [], outflow:[], months:[]};
    const newDate = new Date();

    for (let i=0; i <= 5; i++){

      record.inflow.unshift(0);
      record.outflow.unshift(0);
      record.months.unshift(newDate.toLocaleDateString("en-US", {month: "short"}))

      for (let j=(trnx.length - 1); j >= 0; j--){

        if (newDate.getMonth() === (new Date(trnx[j].tranTime).getMonth())){

          if (transactionCat(trnx[j].tranType) === "DEBIT"){
            record.outflow[0] = Math.round(record.outflow[0] + trnx[j].tranAmount);
          }
          else if (transactionCat(trnx[j].tranType) === "CREDIT"){
            record.inflow[0] = Math.round(record.inflow[0] + trnx[j].tranAmount);
          }
          trnx.pop();
        }
        else {
          break;
        }
      }
      newDate.setMonth(newDate.getMonth()-1);
    }

    
    const options = {
        "series": [
          {
            "name": "Cash Inflow",
            "data": record.inflow
          },
          {
            "name": "Cash Outflow",
            "data": record.outflow
          }
        ],
        "chart": {
          "type": "bar",
          "height": 350,
          "toolbar": {
            "show": false
          }
        },
        "plotOptions": {
          "bar": {
            "horizontal": false,
            "columnWidth": [
              "30%"
            ],
            "endingShape": "rounded"
          }
        },
        "legend": {
          "show": false
        },
        "dataLabels": {
          "enabled": false
        },
        "stroke": {
          "show": true,
          "width": 2,
          "colors": [
            "transparent"
          ]
        },
        "xaxis": {
          "categories": record.months,
          "axisBorder": {
            "show": false
          },
          "axisTicks": {
            "show": false
          },
          "labels": {
            "style": {
              "colors": "#B5B5C3",
              "fontSize": "12px",
              "fontFamily": "Poppins"
            }
          },
          "convertedCatToNumeric": false
        },
        "yaxis": [
          {
            "show": true,
            "showAlways": false,
            "showForNullSeries": true,
            "opposite": false,
            "reversed": false,
            "logarithmic": false,
            "forceNiceScale": false,
            "floating": false,
            "labels": {
              "show": true,
              "minWidth": 0,
              "maxWidth": 160,
              "offsetX": 0,
              "offsetY": 0,
              "rotate": 0,
              "padding": 20,
              "style": {
                "colors": "#B5B5C3",
                "fontSize": "12px",
                "fontWeight": 400,
                "fontFamily": "Poppins",
                "cssClass": ""
              },
              formatter: value => formatAmount(currency, value)
            },
            "axisBorder": {
              "show": false,
              "color": "#e0e0e0",
              "width": 1,
              "offsetX": 0,
              "offsetY": 0
            },
            "axisTicks": {
              "show": false,
              "color": "#e0e0e0",
              "width": 6,
              "offsetX": 0,
              "offsetY": 0
            },
            "title": {
              "rotate": -90,
              "offsetY": 0,
              "offsetX": 0,
              "style": {
                "fontSize": "11px",
                "fontWeight": 900,
                "cssClass": ""
              }
            },
            "tooltip": {
              "enabled": false,
              "offsetX": 0
            },
            "crosshairs": {
              "show": true,
              "position": "front",
              "stroke": {
                "color": "#b6b6b6",
                "width": 1,
                "dashArray": 0
              }
            }
          }
        ],
        "fill": {
          "opacity": 1
        },
        "states": {
          "normal": {
            "filter": {
              "type": "none",
              "value": 0
            }
          },
          "hover": {
            "filter": {
              "type": "none",
              "value": 0
            }
          },
          "active": {
            "allowMultipleDataPointsSelection": false,
            "filter": {
              "type": "none",
              "value": 0
            }
          }
        },
        "tooltip": {
          "style": {
            "fontSize": "12px",
            "fontFamily": "Poppins"
          },
          "y": {}
        },
        "colors": [
          "#1BC5BD",
          "#E4E6EF"
        ],
        "grid": {
          "borderColor": "#EBEDF3",
          "strokeDashArray": 4,
          "yaxis": {
            "lines": {
              "show": true
            }
          }
        },
        "annotations": {
          "yaxis": [],
          "xaxis": [],
          "points": []
        }
      }

    return <ReactApexChart options={options} series={options.series} type="bar" height={350} />

}

export default TransactionChart;